import { useEffect, useRef, useState } from 'react';

export const useIntersectionObserver = (options = {}) => {
  const { threshold = 1, root = null, rootMargin = '0%', reInitializeOnChange = false } = options;

  const ref = useRef(null);
  const [isInViewport, setIsInViewport] = useState(null);
  useEffect(() => {
    const node = ref?.current;

    if (!node || typeof IntersectionObserver !== 'function') {
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsInViewport(entry.isIntersecting);
      },
      { threshold, root, rootMargin },
    );

    observer.observe(node);

    return () => {
      setIsInViewport(null);
      observer.disconnect();
    };
  }, [threshold, root, rootMargin, reInitializeOnChange]);

  return [ref, isInViewport];
};
